import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "DamageListPage" */
	'pages/vehicle/Damage/DamageListPage'));

export default [{ component, exact: true, path: '/damages' }];